import "./style.scss";

type MapButtonProps = {
	isDisabled: boolean;
	icon: React.ReactElement;
	handleClick: () => void;
};

export const MapButton = ({
	icon,
	isDisabled,
	handleClick,
}: MapButtonProps) => {
	return (
		<button
			disabled={isDisabled}
			className="map-button"
			onClick={() => handleClick()}
		>
			{icon}
		</button>
	);
};

export default MapButton;
